<template>
  <div id="app">
    <!--<div id="nav">
      <router-link to="/">Main</router-link> |
      <router-link to="/static">Estatico (para dev)</router-link>
      <router-link to="/pruebas">Pruebas (para dev)</router-link>
      <div class="locale-changer">
        <select v-model="$i18n.locale">
          <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
            {{ lang }}
          </option>
        </select>
      </div>
    </div>-->
    <router-view/>
  </div>
</template>

<script>
export default {name: 'app_layout', data() {
    return {
      //langs: ['es', 'en'],

    }

  },
  created() {
    let pais = this.$route.params.pais
    this.$store.commit('setPais',pais)
  },
  mounted: function () {


    this.$store.dispatch('initFromBackend')




  }}
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}*/
</style>
